import { writable, derived } from 'svelte/store';

// Step 1: Roast (Drip / Espresso) — first step so customers commit to roast profile
export const roast = writable('');
export const roastDisplayValue = writable('');

// Step 2: Coffee selection from the rotation
// null = "Curated by our team"; product object = specific coffee
export const coffee = writable(null);
export const coffeeDisplayValue = derived(coffee, ($coffee) =>
  $coffee ? $coffee.title : ''
);

// Filters for step 2 coffee browsing
export const processingFilters = writable([]); // e.g. ['Washed', 'Natural', 'Honey / Alternative']
export const flavorFilters = writable([]);     // e.g. ['Classic', 'Unique']
export const descriptorFilters = writable([]); // e.g. ['Chocolate', 'Fruity', 'Rich', 'Delicate', 'Complex']

// Step 3: Bag size / quantity
export const size = writable('');
export const sizeDisplayValue = writable('');

// Step 4: Shipping frequency
export const shippingFrequency = writable([null, null]);
export const shippingFrequencyDisplayValue = writable('');

// Kept for backward-compat with propertyOption; we always use "Pay Per Shipment" now
export const paymentFrequency = writable(['Pay Per Shipment', null]);
export const paymentFrequencyDisplayValue = writable('Pay Per Shipment');

export const standardizedPaymentFrequency = derived(
  [paymentFrequency, shippingFrequency],
  ([$paymentFrequency, $shippingFrequency], set) => {
    if ($shippingFrequency[1] === 'Weeks' && $paymentFrequency[1] === 'Months') {
      set([$paymentFrequency[0] * 4, 'Weeks']);
    } else {
      set($paymentFrequency);
    }
  }
);

// Flavor store alias kept so propertyOption.svelte doesn't break if it's used elsewhere
export const flavor = writable('');
export const flavorDisplayValue = writable('');
